import React, { Component, Fragment } from 'react';
import { Table, Input } from 'reactstrap';
import { ContactContext } from './context'
import { childDocument } from '../configData';
import { postSharedRecord } from '../../services';
import HandleSharing from '../HandleSharing';
import { toast } from 'react-toastify';


class ChildTable extends Component {

  static contextType = ContactContext;

  state = {
    recordList: []
  }

  handleCheckbox = (event, recordId) => {
    let checked = event.target.checked;
    let { recordList } = this.state;
    const index = recordList.indexOf(recordId);
    if(checked == true) {
      if(index < 0) {
        recordList.push(recordId);
      }
    } else {
      if(index >= 0) {
        recordList.splice(index, 1)
      } 
    }

    this.setState(prevState => ({
      recordList: [...recordList]
    }))
  }

  handleShareRecord = async (message) => {

    const { recordList } = this.state;
    const contact = this.context.contact;
    const model = this.context.model
    
    if(contact == "") {
      toast.error("Please select an contact");
      return;
    } 

    if(recordList.length < 1) {
      toast.error("Select any record to share")
      return;
    }

    let data = {
      recordList,
      contact,
      model,
      message
    }

    const response = await postSharedRecord(data);
    toast.success("Your record is successfully shared");
  }

  render() {

    const { records } = this.props;
    return (
      <Fragment>
          <Table>
            <thead className="tableHeader">
              <tr>
                <th>S.No</th>
                <th>Date of Appointment</th>
                <th>Hospital/Clinic</th>
                <th>Doctor Name</th>
                <th>Sub Type of Document</th>
                <th>Title of Document(s)</th>
                <th>Select</th>
              </tr>
            </thead>
            {records.map((record, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{record.document.appointment}</td>
                <td>{record.hospitalName}</td>
                <td>{record.doctorName}</td>
                <td>{childDocument[record.subDocumentType]['label']}</td>
                <td>{record.document.title}</td>   
                <td><Input type="checkbox" onClick={(event) => this.handleCheckbox(event, record._id)}/></td>         
              </tr>
            ))}
          </Table>
          <HandleSharing handleShareRecord={this.handleShareRecord}/>
      </Fragment>
      
    )
  }
}

export default ChildTable;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareMyRecord/ChildTable.js